import { render } from "./VillaFacility.vue?vue&type=template&id=487549b8&scoped=true"
import script from "./VillaFacility.vue?vue&type=script&lang=js"
export * from "./VillaFacility.vue?vue&type=script&lang=js"

import "./VillaFacility.vue?vue&type=style&index=0&id=487549b8&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487549b8"]])

export default __exports__